import script from "./total-deals.vue?vue&type=script&setup=true&lang=js"
export * from "./total-deals.vue?vue&type=script&setup=true&lang=js"

import "./total-deals.vue?vue&type=style&index=0&id=30d486c8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30d486c8"]])

export default __exports__